import React from "react";
import { Icon } from "./siIcons";
import { siApi } from "./siApi";
import SiUtilisateurs from "./SiUtilisateurs";
import SiSysteme from "./SiSysteme";
import "./SI.css";
import "./SIAjouts.css";

// Écran « Système d'information » (section Administrateur, module Admin) —
// maquette claude-design/si.jsx + si-system.jsx, branchée sur l'API S.I
// (backend-myalfa routes/siRoutes.js). Trois onglets : Utilisateurs (comptes
// MyALFA remontés automatiquement + utilisateurs hors système, accès
// logiciels, arrivées / sorties), Système (documentation de
// l'infrastructure du cabinet) et Sauvegardes (statistiques des rapports
// quotidiens + tableau des sauvegardes, sorti de Système le 20/10/2026).

const CLE_ONGLET = "myalfa.si.tab";
const lireOnglet = () => {
  try {
    return localStorage.getItem(CLE_ONGLET) || "users";
  } catch (e) {
    return "users";
  }
};

export default function SI() {
  const [tab, setTab] = React.useState(lireOnglet);
  const [lignes, setLignes] = React.useState([]);
  const [ref, setRef] = React.useState({ sites: [], services: [], applications: [] });
  const [chargement, setChargement] = React.useState(true);
  const [toast, setToast] = React.useState(null);

  React.useEffect(() => {
    try {
      localStorage.setItem(CLE_ONGLET, tab);
    } catch (e) {
      // stockage indisponible : l'onglet n'est simplement pas mémorisé
    }
  }, [tab]);

  // Message en bas d'écran : { msg, type: "ok" | "erreur", info, undo }.
  const notifier = React.useCallback((msg, opts = {}) => setToast({ msg, id: Date.now(), ...opts }), []);
  React.useEffect(() => {
    if (!toast) return undefined;
    const h = setTimeout(() => setToast(null), toast.undo || toast.info || toast.type === "erreur" ? 7000 : 4000);
    return () => clearTimeout(h);
  }, [toast]);

  React.useEffect(() => {
    let actif = true;
    Promise.all([siApi.utilisateurs(), siApi.referentiel()])
      .then(([u, r]) => {
        if (!actif) return;
        setLignes(u);
        setRef(r);
      })
      .catch((e) => actif && notifier(e.message, { type: "erreur" }))
      .finally(() => actif && setChargement(false));
    return () => {
      actif = false;
    };
  }, [notifier]);

  const outils = ref.applications.filter((a) => a.caseAcces);
  const live = lignes.filter((r) => r.statut !== "sorti");
  const setApps = React.useCallback((f) => setRef((r) => ({ ...r, applications: typeof f === "function" ? f(r.applications) : f })), []);

  return (
    <div className="six">
      <div className="page si-page">
        <div className="page-head">
          <div className="page-title">
            <h1>Système d'information</h1>
            <p>Utilisateurs, accès et organisation informatique du cabinet</p>
          </div>
        </div>
        <div className="tk-tabs" role="tablist">
          {[["users", "Utilisateurs", "user", chargement ? null : live.length], ["system", "Système", "grid", null], ["backup", "Sauvegardes", "archive", null]].map(([k, l, ic, n]) => (
            <button key={k} role="tab" aria-selected={tab === k} className={tab === k ? "is-active" : ""} onClick={() => setTab(k)}>
              <Icon name={ic} size={15} />{l}{n != null && <span className="tk-tab-n">{n}</span>}
            </button>
          ))}
        </div>
        {tab === "system" && <SiSysteme lignes={live} apps={ref.applications} setApps={setApps} sites={ref.sites} onUsers={() => setTab("users")} notifier={notifier} />}
        {tab === "backup" && <SiSysteme vue="sauvegardes" lignes={live} apps={ref.applications} setApps={setApps} sites={ref.sites} onUsers={() => setTab("users")} notifier={notifier} />}
        {tab === "users" && (
          <SiUtilisateurs lignes={lignes} setLignes={setLignes} outils={outils} sites={ref.sites} services={ref.services} chargement={chargement} notifier={notifier} />
        )}
        {toast && (
          <div className={`tk-toast ${toast.type === "erreur" ? "six-toast-err" : ""}`} key={toast.id} role="status" aria-live="polite">
            <Icon name={toast.type === "erreur" ? "info" : "check"} size={14} />
            <span className="six-toast-t">
              {toast.msg}
              {toast.info && <small>{toast.info}</small>}
            </span>
            {toast.undo && (
              <button
                onClick={() => {
                  toast.undo();
                  setToast(null);
                }}
              >
                Annuler
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
